export default __webpack_public_path__ + "static/media/logo.5f9d6f27.svg";